import validate from "/app/node_modules/.pnpm/nuxt@3.17.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.21_better-sqli_1de79a473deff2d22cc5eae2718a5b86/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/app/node_modules/.pnpm/nuxt@3.17.4_@netlify+blobs@8.2.0_@parcel+watcher@2.5.1_@types+node@22.15.21_better-sqli_1de79a473deff2d22cc5eae2718a5b86/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {
  authentication: () => import("/app/middleware/authentication.ts")
}